//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ContentItemTypes {
	Content = 0,
	Assessment = 1,
	ContentSegment = 2,
	ExternalContent = 3,
	Thread = 4
}
